import styled from "vue-styled-components";

export const Content = styled.section`
    .card-body {
        display: flex;
        border: 1px solid #ddd;
        > a {
            color: orange;
            font-size: 15px;
            margin-left: auto;
        }

        span {
            width: 200px;
            padding: 6px 30px;
            border-radius: 0 6px 6px 0;
            text-align: start;
            color: white;
        }

        .bg-warning {
            color: black !important;
        }
    }

    @media (max-width: 768px) {
        .card-body {


            > a {
                margin-top: -2rem;
            }
        }
    }
`;
